import { ActionKeys } from './constants';

import { FeatureTestUserVariant } from '~/types/FeatureTest';

export function fetchFeatureTests() {
  return <const>{
    type: ActionKeys.FETCH_AB_TEST_FEATURES,
  };
}

export function fetchFeatureTestSuccess(featureTestUserVariants: FeatureTestUserVariant[]) {
  return <const>{
    type: ActionKeys.FETCH_AB_TEST_FEATURES_SUCCESS,
    payload: {
      featureTestUserVariants,
    },
  };
}

export function rollTestFeatureDiceSuccess(featureTestUserVariant: FeatureTestUserVariant) {
  return <const>{
    type: ActionKeys.ROLL_FEATURE_TEST_DICE_SUCCESS,
    payload: {
      featureTestUserVariant,
    },
  };
}

export function rollFeatureTestDice(featureTestName: string) {
  return <const>{
    type: ActionKeys.ROLL_FEATURE_TEST_DICE,
    payload: {
      featureTestName,
    },
  };
}

export function assignFeatureTestVariant(featureTestName: string, variantName: string) {
  return <const>{
    type: ActionKeys.FEATURE_TEST_ASSIGN,
    payload: {
      featureTestName,
      variantName,
    },
  };
}

export function assignFeatureTestVariantSuccess(featureTestUserVariant: FeatureTestUserVariant) {
  return <const>{
    type: ActionKeys.FEATURE_TEST_ASSIGN_SUCCESS,
    payload: {
      featureTestUserVariant,
    },
  };
}

export function assignFeatureTestVariantError() {
  return <const>{
    type: ActionKeys.FEATURE_TEST_ASSIGN_ERROR,
  };
}

export function initializeFeatureTestVariantNames() {
  return <const>{
    type: ActionKeys.INITIALIZE_FEATURE_TEST_VARIANT_NAMES,
  };
}

export type FeatureTestsActions =
  | ReturnType<typeof fetchFeatureTests>
  | ReturnType<typeof fetchFeatureTestSuccess>
  | ReturnType<typeof rollTestFeatureDiceSuccess>
  | ReturnType<typeof rollFeatureTestDice>
  | ReturnType<typeof assignFeatureTestVariant>
  | ReturnType<typeof assignFeatureTestVariantSuccess>
  | ReturnType<typeof assignFeatureTestVariantError>
  | ReturnType<typeof initializeFeatureTestVariantNames>;
